import React from 'react';
import { Remover } from '../FormComponents';

interface Props {
  onClick: () => void;
  isNew: boolean;
  children: string;
}

export const DeleteOrDiscard: React.FC<Props> = ({ onClick, isNew, children }) => (
  <Remover onClick={onClick}>{isNew ? 'Discard changes' : children}</Remover>
);
